var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutForm",
    [
      _c("h1", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v("Create MADD"),
      ]),
      _vm._v(" "),
      _c("FormStepNav", {
        attrs: {
          slot: "nav",
          "total-steps": _vm.totalSteps,
          "current-step": _vm.currentStep,
          "completed-step": _vm.completedStep,
          "route-base": _vm.routeBase,
        },
        slot: "nav",
      }),
      _vm._v(" "),
      _vm.currentStep === 1 ? _c("MADDFormStep1") : _vm._e(),
      _vm._v(" "),
      _vm.currentStep === 2 ? _c("MADDFormStep2") : _vm._e(),
      _vm._v(" "),
      _vm.currentStep === 3 ? _c("MADDFormStep3") : _vm._e(),
      _vm._v(" "),
      _vm.currentStep === 4 ? _c("MADDFormStep4") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }